var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChromeCastDisconnectedIcon = function SvgChromeCastDisconnectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 31.833h-1.5v3H25zM1.834 11.667v1.5h3v-1.5zM5 8.166h30v-3H5zm30.167.166v23.333h3V8.334zM35 31.833H25v3h10zM4.834 11.667V8.333h-3v3.333zm30.333 20a.167.167 0 0 1-.167.166v3a3.167 3.167 0 0 0 3.167-3.166zM35 8.166c.092 0 .167.074.167.166h3A3.167 3.167 0 0 0 35 5.167zm-30-3a3.167 3.167 0 0 0-3.166 3.166h3c0-.092.074-.167.166-.167zM1.667 26.5a8.5 8.5 0 0 1 8.5 8.5h3c0-6.351-5.149-11.5-11.5-11.5zm0-6.667c8.376 0 15.167 6.79 15.167 15.167h3c0-10.033-8.134-18.167-18.167-18.167zm0 14.167a1 1 0 0 1 1 1h3a4 4 0 0 0-4-4z"
  })));
};
export default SvgChromeCastDisconnectedIcon;